<ul class="layout-menu">
    <li *ngIf="!showLimitedMenu" class="back-to-global-menu" (click)="onBackToGlobalMenuClick()">&lt; Back to Global Menu</li>
    <ng-container *ngFor="let item of model; let i = index;">
        <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
        <li *ngIf="item.separator" class="menu-separator"></li>
    </ng-container>
</ul>
<p-dialog
  [(visible)]="showBackToGlobalMenuModal"
  [modal]="true"
  [closable]="false"
  [dismissableMask]="false"
  [breakpoints]="{'1200px': '50vw', '768px': '75vw', '576px': '90vw'}"
  [style]="{ width: '30vw', minWidth: '350px' }"
  styleClass="back-to-global-dialog"
  appendTo="body"
  [baseZIndex]="10000"
>
  <div class="dialog-content-center">
    <i class="pi pi-sign-out big-icon"></i>
    <div class="main-text">Are you sure you want to navigate to the Global Menu?</div>
    <div class="sub-text">Are you sure you want to leave the program menu? You will be navigated to the global menu.</div>
     <div class="dialog-actions">
      <button
        pButton
        type="button"
        class="p-button-text p-button-outlined wide-btn"
        (click)="showBackToGlobalMenuModal = false"
      >
        Cancel
      </button>
      <button
        pButton
        type="button"
        class="p-button-primary wide-btn"
        (click)="leaveToGlobalMenu()"
      >
        Leave
      </button>
    </div>
  </div>
</p-dialog>
